import { btnS } from "../../../lib/styles.js";
import {
  C, font, mono, PageWrap, SectionHeader, StatPill, StatusPill, Chip, EmptyState,
  JobCard, PipelineStrip, PIPELINE_STEPS, groupByShoot, ShootGroup,
} from "../components/ui.jsx";
import { getRecipe, getControlSet } from "../lib/recipes.js";
import { SUBJECT_TYPE_LABELS } from "../lib/mockData.js";

export default function ProcessingView({ jobs, onCancel }) {
  const processing = jobs.filter((j) => j.status === "processing");

  return (
    <PageWrap>
      <SectionHeader
        eyebrow="In Process"
        title="Processing"
        subtitle={processing.length ? `${processing.length} job${processing.length === 1 ? "" : "s"} running on the worker` : "Nothing running"}
        right={<StatPill value={processing.length} label="Running" color={C.purple} />}
      />

      {processing.length === 0 ? (
        <EmptyState
          title="Nothing processing right now"
          body="Approved jobs from the Queue run here. You'll see each one move through the pipeline."
        />
      ) : (
        groupByShoot(processing).map((g) => (
          <ShootGroup key={g.shoot.id} shoot={g.shoot} count={g.jobs.length}>
            {g.jobs.map((job) => <ProcessingRow key={job.id} job={job} onCancel={onCancel} />)}
          </ShootGroup>
        ))
      )}
    </PageWrap>
  );
}

function ProcessingRow({ job, onCancel }) {
  const recipe = getRecipe(job.recipeId);
  const control = getControlSet(job.controlSet);
  const { step, progress, started } = job.processing || {};
  const stepName = PIPELINE_STEPS[step] || "—";

  return (
    <JobCard status="processing">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 14 }}>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 14, fontWeight: 400, color: C.text, marginBottom: 5 }}>{job.label}</div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
            <Chip color={C.amber}>{recipe?.name || "—"}</Chip>
            <span style={{ fontSize: 11, color: C.muted }}>
              {SUBJECT_TYPE_LABELS[job.subjectType] || "Object"} · {control?.label || "—"} · {job.photoCount} photos
            </span>
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 8, flexShrink: 0 }}>
          <StatusPill status="processing" />
          <button style={{ ...btnS, padding: "4px 10px", fontSize: 11 }} onClick={() => onCancel?.(job.id)}>
            Cancel
          </button>
        </div>
      </div>

      <PipelineStrip currentStep={step} />

      <div style={{ marginTop: 12 }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
          <span style={{ fontSize: 11, color: C.purple, fontWeight: 500 }}>{stepName}</span>
          <span style={{ fontSize: 11, color: C.muted }}>{progress}% · started {started}</span>
        </div>
        <div style={{ height: 5, background: C.surfaceAlt, borderRadius: 3, overflow: "hidden" }}>
          <div style={{ width: `${progress}%`, height: "100%", background: C.purple, transition: "width 0.3s ease" }} />
        </div>
        <div style={{ marginTop: 8, display: "flex", gap: 6, flexWrap: "wrap" }}>
          {(recipe?.variants || []).map((v) => (
            <Chip key={v.name} color={C.muted}>{v.name} · {v.texture}</Chip>
          ))}
        </div>
      </div>
    </JobCard>
  );
}
